import { render, staticRenderFns } from "./bookingDetails.vue?vue&type=template&id=2ca95e6f&scoped=true"
import script from "./bookingDetails.vue?vue&type=script&lang=js"
export * from "./bookingDetails.vue?vue&type=script&lang=js"
import style0 from "./bookingDetails.vue?vue&type=style&index=0&id=2ca95e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca95e6f",
  null
  
)

export default component.exports